module.exports = __webpack_public_path__ + "img/20180815_150347_084.9f7b3fc4.jpg";